<template>
  <div class="right_col" role="main" style="min-height: 756px">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>{{ $t('adPage.recommendOnOrderList') }}</h3>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="x_panel item_list">
        <div class="x_content">
          <alert
            :title="alertTitle"
            :success-message="$t('common.isSuccess')"
            :error-message="$t('common.isFailure')"
            :alerts="alerts"
            :errors="errors"
            :display="alertDisplay"
            @closeAlert="closeAlert"
          />
          <div class="text-right">
            <button
              :disabled="!groupsReady && !itemsReady"
              @click="create"
              class="btn btn-primary"
            >
              {{ $t('common.create') }}
            </button>
          </div>
          <div
            id="datatable_wrapper"
            class="dataTables_wrapper form-inline dt-bootstrap no-footer"
          >
            <div class="row">
              <div class="col-sm-6">
                <table-length @changeRowPerPage="changeRowPerPageCount" />
              </div>
              <div class="col-sm-6">
                <div id="datatable_filter" class="dataTables_filter">
                  <label
                    >{{ $t('common.search') }}:
                    <input
                      v-model="searchString"
                      @keyup="searchWord"
                      type="search"
                      class="form-control input-sm"
                      placeholder=""
                      aria-controls="datatable"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <app-table
                  :shops-ready="groupsReady"
                  :items-ready="itemsReady"
                  :for-recommends="true"
                  :display-items="displayItems"
                  :column-titles="tableHeaderColumns"
                  @buttonClickEvent="buttonClickEvent"
                  @sortTable="sortTable"
                />
              </div>
            </div>
            <pagination
              :page-par-item-count="displayItemPerPageCount"
              :total-item-count="totalItemCount"
              :current-page="currentPage"
              @changePage="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import { getServerDateTime, getTimezone } from '@/utility/time'
import list from '@/mixin/list'
import alert from '@/mixin/alert'

import Alert from '@/components/common/alert/Alert'
import Pagination from '@/components/tabale/Pagination'
import Table from '@/components/common/table/Table'
import TableLength from '@/components/tabale/TableLength'
import OrderRecommendRequest from '@/http/OrderRecommendRequest'

export default {
  components: {
    Alert,
    Pagination,
    TableLength,
    AppTable: Table,
  },
  mixins: [list, alert],
  data() {
    return {
      groupsReady: false,
      itemsReady: false,
    }
  },
  computed: {
    ...mapGetters({
      fetchedData: 'orderRecommend/getOrderRecommends',
      fetchedItems: 'item/getItems',
      fetchedGroups: 'shop/getGroupToShops',
      language: 'settings/getLanguage',
    }),
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
    startTime() {
      return (
        this.$t('common.startTime') + (this.isJp ? '' : `(${this.timezone})`)
      )
    },
    endTime() {
      return this.$t('common.endTime') + (this.isJp ? '' : `(${this.timezone})`)
    },
    timezone() {
      return getTimezone()
    },
    tableHeaderColumns() {
      return [
        'ID',
        this.$t('common.implementationGroup'),
        this.$t('common.menuOnOrder'),
        this.$t('common.recommendMenu'),
        this.startTime,
        this.endTime,
        this.$t('common.edit'),
        this.$t('common.delete'),
      ]
    },
  },
  watch: {
    fetchedData: function(data) {
      this.fetchItems = data.map((item) => {
        const recommendItemString = item.recommendList.map((item) => item.name)
        const name =
          item.itemName === null
            ? `<strong style="color:red">${this.$t(
                'adPage.itemIsYetNotRegistered'
              )}</strong>`
            : item.itemName

        return [
          item.orderRecommendId,
          item.groupList.map((x) => x.name).join('\n'),
          name,
          recommendItemString.join(' '),
          getServerDateTime(item.displayStartAt).format('YYYY-MM-DD'),
          getServerDateTime(item.displayEndAt).format('YYYY-MM-DD'),
          { type: 'edit', id: item.orderRecommendId },
          { type: 'destroy', id: item.orderRecommendId },
        ]
      })
      this.allItems = this.fetchItems
      this.totalItemCount = this.allItems.length
      this.displayItems = this.allItems.slice(0, this.displayItemPerPageCount)
    },
    fetchedGroups: function(group) {
      if (group.length > 0) {
        this.groupsReady = true
      }
    },
    fetchedItems: function(items) {
      if (items.list.length > 0) {
        this.itemsReady = true
      }
    },
    language() {
      this.$store.dispatch('orderRecommend/getOrderRecommends')
      this.$store.dispatch('item/getItems')
      this.$store.dispatch('shop/getGroups')
    },
  },
  mounted() {
    if (this.$route.params.succeeded === true) {
      this.alertTitle = this.$route.params.title
      this.openSuccessAlert()
    }

    this.$store.dispatch('orderRecommend/getOrderRecommends')
    this.$store.dispatch('item/getItems')
    this.$store.dispatch('shop/getGroups')
  },
  methods: {
    buttonClickEvent: function(type, id) {
      if (type === 'edit') {
        this.edit(id)
      } else if (type === 'destroy') {
        this.destroy(id)
      }
    },
    edit: function(id) {
      if (this.groupsReady && this.itemsReady) {
        this.$router.push({
          name: 'orderRecommendFormEdit',
          params: { id: id },
        })
      }
    },
    create: function() {
      if (this.groupsReady && this.itemsReady) {
        this.$router.push({ name: 'orderRecommendForm' })
      }
    },
    destroy: function(id) {
      if (
        !window.confirm(this.$t('adPage.recommendOnOrderDeletionConfirmation'))
      ) {
        return false
      }

      const request = new OrderRecommendRequest()
      const params = {}
      request
        .delete(id, params)
        .then(() => {
          this.openSuccessAlert()
        })
        .catch((err) => {
          this.openErrorAlert(err.response.data)
        })
        .finally(() => {
          this.alertTitle = this.$t('adPage.deleteRecommendOnOrder')
          const params = { master: 1 }
          this.$store.dispatch('orderRecommend/getOrderRecommends', params)
        })
    },
    sortTable: function(newArray) {
      this.displayItems = newArray
    },
  },
}
</script>
